export default "__VITE_PUBLIC_ASSET__95ee2562__"